import { useEffect, useState } from "react";
import { Button, Col, Modal, ModalHeader, Row } from "reactstrap";
import { useAppSelector } from "../../../../../../reduxToolkit/hooks";
import { ProductItems, ProductModalProps } from "../../../../../../types/Ecommerce";
import { dynamicImage } from "../../../../../../utils";
import Buttons from "./Buttons";
import Details from "./Details";
import Quantity from "./Quantity";
import { Image } from "../../../../../../coreComponents/Image";

// This component displays a modal with product details and allows the user to select quantity and add to cart.
const ProductModal: React.FC<ProductModalProps> = ({ value, setOpenModal, dataId }) => {
  const [open, setOpen] = useState(value);
  const { productItem } = useAppSelector((state) => state.product);
  const [quantity, setQuantity] = useState<number>(1);
  const [singleProduct, setSingleProduct] = useState<ProductItems | undefined | [] | any>([]);

  // to find the product with the given dataId from the product list
  useEffect(() => {
    productItem.forEach((product: ProductItems) => {
      if (product.id === dataId) setSingleProduct(product);
    });
  }, [productItem, dataId]);

  const onCloseModal = () => {
    setOpen(false);
    setOpenModal(false);
  };

  return (
    <Modal centered size="lg" isOpen={open} toggle={onCloseModal}>
      <ModalHeader className="position-relative border-0">
        <Button color="transparent" onClick={onCloseModal} className="btn-close"></Button>
        <Row className="product-box align-items-center">
          <Col lg="6" className="product-img">
            {singleProduct?.image && <Image className="img-fluid" src={dynamicImage(singleProduct?.image)} alt="image" />}
          </Col>
          <Col lg="6" className="product-details text-start">
            <Details singleProduct={singleProduct} />
            <div className="product-qnty">
              <Quantity quantity={quantity} setQuantity={setQuantity} />
              <Buttons singleProduct={singleProduct} quantity={quantity} />
            </div>
          </Col>
        </Row>
      </ModalHeader>
    </Modal>
  );
};
export default ProductModal;
